import React from "react";
import { StoryblokVideoHero } from "../../../interfaces/Storyblok/StoryblokVideoHero.interface";
import { ButtonProps } from "../../../interfaces/Button.interface";
import { ButtonTypes } from "../../../interfaces/enums/ButtonTypes.enum";
import { ButtonSizeTypes } from "../../../interfaces/enums/ButtonSizeTypes.enum";
import YoutubeVideo from "../../atoms/YoutubeVideo/YoutubeVideo.atom";
import Button from "../../atoms/Button/Button.component";
import Crumb from "../../atoms/Crumb/Crumb.atom";

const VideoHero: React.FC<StoryblokVideoHero> = ({ title, description, crumb, youtube_video_id, cta, secondary_cta }) => {
  const isCTAPopulated = (ctaItem?: ButtonProps[]): boolean =>
    Array.isArray(ctaItem) &&
    ctaItem.length > 0 &&
    ctaItem[0].label != undefined &&
    ctaItem[0].link?.cached_url != undefined;

  return (
    <section className="relative flex min-h-[520px] w-full items-center justify-center overflow-hidden md:min-h-[640px]">
      {youtube_video_id && (
        <div className="absolute inset-0 z-0">
          <YoutubeVideo video_id={youtube_video_id} autoplay loop isBackground />
        </div>
      )}

      <div className="absolute inset-0 z-10 bg-Black/50" aria-hidden="true" />

      <div className="container relative z-20 mx-auto flex flex-col items-center px-6 py-16 text-center md:py-24">
        {crumb && <Crumb label={crumb} variant="light" className="mb-6" />}
        {title && (
          <h1 className="max-w-4xl text-4xl font-extrabold leading-tight text-White md:text-5xl">{title}</h1>
        )}
        {description && (
          <p className="mt-6 max-w-3xl text-xl font-medium leading-relaxed text-White">{description}</p>
        )}
        {(isCTAPopulated(cta) || isCTAPopulated(secondary_cta)) && (
          <div className="mt-8 flex flex-col items-center gap-4 sm:flex-row sm:justify-center">
            {cta && isCTAPopulated(cta) && (
              <Button
                link={cta[0].link}
                label={cta[0].label}
                type={ButtonTypes.PRIMARY}
                size={ButtonSizeTypes.XL}
              />
            )}
            {secondary_cta && isCTAPopulated(secondary_cta) && (
              <Button
                link={secondary_cta[0].link}
                label={secondary_cta[0].label}
                type={ButtonTypes.SECONDARY}
                size={ButtonSizeTypes.XL}
              />
            )}
          </div>
        )}
      </div>
    </section>
  );
};

export default VideoHero;
